import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";
import { PopupModule } from "@progress/kendo-angular-popup";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { ThemeModule } from "projects/sepidz-web-framework-shell/src/lib/@theme/theme.module";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { TabularModule } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.module";
import { ReceivedFromRahkaranFormComponent } from "../received-from-rahkaran/received-from-rahkaran-form.component";
import { InvSubledgerDetailLedgerFormComponent } from "./inv-subledger-detailLedger/inv-subledger-detailLedger-form.component";
import { InvVoucherDetailFilterComponent } from "./inv-voucher-detail-filter/inv-voucher-detail-filter.component";
import { InvVoucherHeaderImportExcelFormComponent } from "./inv-voucher-header-import-excel/inv-voucher-header-import-excel-form.component";
import { InvVoucherModalListComponent } from "./inv-voucher-modal-list/inv-voucher-modal-list.component";
import { InvVoucherDetailComponent } from "./invvoucher-detail/invvoucher-detail.component";
import { InvVoucherFormComponent } from "./invvoucher-form/invvoucher-form.component";
import { InvVoucherListComponent } from "./invvoucher-list/invvoucher-list.component";
import { ReferenceVoucherListComponent } from "./reference-voucher-list/reference-voucher-list.component";

const components = [
  InvVoucherListComponent,
  InvVoucherFormComponent,
  InvVoucherDetailComponent,
  ReferenceVoucherListComponent,
  InvVoucherModalListComponent,
  InvVoucherDetailFilterComponent,
  InvSubledgerDetailLedgerFormComponent,
  ReceivedFromRahkaranFormComponent,
  InvVoucherHeaderImportExcelFormComponent,
];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, ThemeModule, TabularModule, DropDownListModule, PopupModule, SharedModule.forRoot(), SepidzGridModule],
})
export class InvvoucherModule {}
